import * as React from "react";

export class Row extends React.Component<{ id: string }, {}> {
    render() {
        return (
            <div className="rj-racing-next-races__row" id={this.props.id}>
                {this.props.children}
            </div>
        )
    }
}